module.exports = new __parcel__URL__("select-business-project.26774f85.svg").toString();